import { useState } from "react";
import { SideContent, MapContent } from "../../components/map"


export default function Map () {

  const [value, setValue] = useState(null)
  const [listValue, setListValue] = useState(null)
  const [typeData, setTypeData] = useState(null)
  const [category, setCategory] = useState(null)
  const [boundaryFilter, setBoundaryFilter] = useState(null)

  return(
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <div
            className="col-md-2 col-sm-12"
            style={{
              background: '#ffffff',
              borderRight: '1px solid #e2e8f0',
              boxShadow: '2px 0 8px rgba(15,23,42,0.04)',
              minHeight: '100vh',
              overflowY: 'auto',
            }}
          >
            <SideContent
              value={value}
              setValue={setValue}
              setListValue={setListValue}
              setTypeData={setTypeData}
              category={category}
              setCategory={setCategory}
              boundaryFilter={boundaryFilter}
              setBoundaryFilter={setBoundaryFilter}
            />
          </div>
          <div className="col-md-10 col-sm-12">
            <MapContent
              value={value}
              category={category}
              listValue={listValue}
              typeData={typeData}
              boundaryFilter={boundaryFilter}
            />
          </div>
        </div>
      </div>
    </div>
  )

}